<template>
  <b-card header="Passcode form">
    <b-form id="create-passcode-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Start</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="startDate" v-model="formData.startdateStr"></b-form-input>
          <b-form-input type="time" id="startTime" v-model="formData.startTimeStr"> </b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>End</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="endDate" v-model="formData.enddateStr" :state="passcodeStateEndDate"
          aria-describedby="inputLiveFeedbackPasscodeEndDate"></b-form-input>
          <b-form-input type="time" id="endTime" v-model="formData.endTimeStr" :state="passcodeStateEndDate"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
          <b-form-invalid-feedback id="inputLiveFeedbackPasscodeEndDate">
            End Date/time should be later than the Start Date/time. Please choose later date for End Date/Time.
          </b-form-invalid-feedback>
        </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group>
            <b-input-group-prepend><b-input-group-text>Label</b-input-group-text></b-input-group-prepend>
            <b-form-input type="text" id="label" v-model="formData.labelPasscode" placeholder="Label"></b-form-input>
            <b-input-group-append><b-input-group-text><i class="fa fa-id-card-o"></i></b-input-group-text></b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group>
            <b-input-group-prepend><b-input-group-text>Passcode</b-input-group-text></b-input-group-prepend>
            <b-form-input
              type="number"
              v-model.trim="formData.keyboardPwd"
              placeholder="Passcode"
              :state="passcodeState"
              aria-describedby="inputLiveFeedbackPasscode"
              ></b-form-input>

            <b-input-group-append><b-input-group-text><i class="fa fa-calculator"></i></b-input-group-text></b-input-group-append>
            <b-form-invalid-feedback id="inputLiveFeedbackPasscode">
              Enter at least 6 numbers max. 9 numbers.
            </b-form-invalid-feedback>
          </b-input-group>
          <div id="passcodeAlreadyExists" style="display:none;color:red;">
            Passcode already exist.
          </div>
        </b-form-group>

        <div class="form-group form-actions">
          <b-button @click="submitData" type="button" size="sm" variant="primary">Assign</b-button>
        </div>
    </b-form>
  </b-card>

</template>

<script>
import PasscodeList from '@/views/base/haus/PasscodeList'
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/passcodes/add'
const API_LIST = BASE + '/api/passcodes/list'

function postdataforlist (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

function postdata (url, data, lockId) {
  const thisForm = document.getElementById('create-passcode-form')
  var partsStartDate = data.startdateStr.split('-')
  var partStartTime = data.startTimeStr.split(':')
  var partsEndDate = data.enddateStr.split('-')
  var partEndTime = data.endTimeStr.split(':')
  data.userName = thisForm.name.value
  data.startdate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2], partStartTime[0], partStartTime[1]).getTime()
  data.enddate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2], partEndTime[0], partEndTime[1]).getTime()
  data.adddate = new Date().getTime()
  data.addType = 2 // check http://open.ttlock.com.cn/doc/api/v3/keyboardPwd/add
  data.lockId = lockId
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId
  }
  let res = await postdataforlist(API_LIST, parameters)
  let result = res.list
  return result
}

export default {
  name: 'passcode-form',
  computed: {
    passcodeState () {
      return (this.formData.keyboardPwd.length > 5 && this.formData.keyboardPwd.length < 10) ? true : false
    },
    passcodeStateEndDate () {
      var partsStartDate = this.formData.startdateStr.split('-')
      var partStartTime = this.formData.startTimeStr.split(':')
      var partsEndDate = this.formData.enddateStr.split('-')
      var partEndTime = this.formData.endTimeStr.split(':')
      let startdate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2], partStartTime[0], partStartTime[1]).getTime()
      let enddate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2], partEndTime[0], partEndTime[1]).getTime()
      return (startdate < enddate) ? true : false
    }
  },
  data () {
    return {
      passcodeNotExists: true,
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: '',
        email: '',
        name: '',
        phone: '',
        keyboardPwd: '',
        addType: '',
        adddate: '',
        adddateStr: '',
        enddate: '',
        enddateStr: '',
        endTime: '',
        endTimeStr: '',
        startdate: '',
        startdateStr: '',
        startTime: '',
        startTimeStr: '',
        labelPasscode: ''
      }
    }
  },
  mounted () {
    this.$data.formData.adddateStr = constants.getToday()
    this.$data.formData.startdateStr = constants.getToday()
    this.$data.formData.enddateStr = constants.getEndDate()
    this.$data.formData.startTimeStr = constants.getTimeNow()
    this.$data.formData.endTimeStr = constants.getTimeNow()
  },
  props: ['locationName', 'locationId', 'locationDescription', 'modalId'],
  components: {
    PasscodeList
  },
  methods: {
    submitData () {
      let lockId = this.$route.params.lockId
      var x = document.getElementById('passcodeAlreadyExists')
      x.style.display = 'none'
      if (this.passcodeState && this.passcodeStateEndDate) {
        postdata(API, this.formData, lockId)
          .then(data => {
            this.formData.adddateStr = constants.getToday()
            this.formData.startdateStr = constants.getToday()
            this.formData.enddateStr = constants.getEndDate()
            this.formData.startTimeStr = constants.getTimeNow()
            this.formData.endTimeStr = constants.getTimeNow()
            this.formData.keyboardPwd = ''
            if (data.status.errCode === '200') {
              getData(lockId).then(response => {
                this.$root.$emit('passcodeList', response)
              })
              this.$root.$emit('modalShow', false)
            } else {
              x.style.display = 'block'
            }
            console.log(data)
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/PasscodeForm.vue